import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Кастомний хук для оновлення query-параметрів у URL
 */
export const useQueryUpdater = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const setQueryParam = ({ key, value, pathnamePriority, options = {} }) => {
    const currentParams = new URLSearchParams(location.search);

    if (value == null) {
      currentParams.delete(key);
    } else {
      currentParams.set(key, value);
    }

    navigate(
      {
        pathname: pathnamePriority || location.pathname,
        search: currentParams.toString(),
      },
      {
        replace: options.replace ?? true,
      }
    );
  };

  const setMultipleQueryParams = ({
    values,
    pathnamePriority,
    options = {},
  }) => {
    const baseParams = new URLSearchParams(location.search);

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(values)) {
      if (value === null || value === undefined) {
        baseParams.delete(key);
      } else {
        baseParams.set(key, value);
      }
    }

    navigate(
      {
        pathname: pathnamePriority || location.pathname,
        search: baseParams.toString(),
      },
      {
        replace: options.replace ?? true,
      }
    );
  };

  return { setQueryParam, setMultipleQueryParams };
};

export default useQueryUpdater;
